import { updateItemInCollection } from "directus/src/operations";

export async function updateExtension({ id, item }) {
  try {
    const query = {
      fields: [
        "id",
        "end_date",
        "start_date",
        "justification",
        "category.id",
        "category.label",
        "reason.id",
        "reason.label",
        "reason",
        "status",
        "job",
      ],
    };
    const data = await updateItemInCollection("job_extensions", id, item, query);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
